export const addSupplier = async (supplierData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addSuppliers", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...supplierData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = supplierData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Supplier Response:', response);
    return jsonResponse;
};
export const updateSupplier = async (supplierId, supplierData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateSuppliers", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: supplierId, ...supplierData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = supplierData;
        data.id = supplierId;
        jsonResponse.data = data;
    }
    console.log('Update Supplier Response:', response);
    return jsonResponse;
};
export const deleteSupplier = async (supplierId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteSuppliers", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: supplierId})
    });
    return await response.json();
};
